import { Injectable } from '@angular/core';
import { NewResidenceModalComponent } from '@app/my-zone/shared/modals/new-residence-modal/new-residence.modal';
import { ReplacementSalesfunnelModal } from '@app/my-zone/shared/modals/replacement-salesfunnel/replacement-salesfunnel.modal';
import { NewModal as ModalService, PurchasedProductInterface } from 'outshared-lib';
import { InsuranceCancelAddedProductModal, InsuranceEndProductSuccessModal, InsuranceReviveProductModal } from '../shared/insurance-end-product';
import { NewHomeFeedbackModal } from '../shared/new-home-feedback/new-home-feedback.modal';

@Injectable({
    providedIn: 'root',
})
export class InsuranceModalService {

    constructor(private modalService: ModalService) {}

    public cancelAddedProductModal(purchasedProduct: PurchasedProductInterface): void {
        this.modalService.open<InsuranceCancelAddedProductModal>(InsuranceCancelAddedProductModal)
            .componentInstance.purchasedProduct = purchasedProduct;
    }

    public endProductSuccessModal(purchasedProduct: PurchasedProductInterface): void {
        this.modalService.open<InsuranceEndProductSuccessModal>(InsuranceEndProductSuccessModal)
            .componentInstance.purchasedProduct = purchasedProduct;
    }

    public newHomeFeedbackModal(purchasedProduct: PurchasedProductInterface): void {
        this.modalService.open<NewHomeFeedbackModal>(NewHomeFeedbackModal)
            .afterClosed$()
            .subscribe(() => this.endProductSuccessModal(purchasedProduct));
    }

    public reviveProductModal(purchasedProduct: PurchasedProductInterface): void {
        this.modalService.open<InsuranceReviveProductModal>(InsuranceReviveProductModal)
            .componentInstance.purchasedProduct = purchasedProduct;
    }

    public replaceVehicleModal(purchasedProduct: PurchasedProductInterface): void {
        this.modalService.open<ReplacementSalesfunnelModal>(ReplacementSalesfunnelModal)
            .componentInstance.purchasedProduct = purchasedProduct;
    }

    public newHomeModal(): void {
        this.modalService.open<NewResidenceModalComponent>(NewResidenceModalComponent);
    }
}
